import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { X, Lock } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Lets the currently logged-in admin change their own password.
// On success, updates the stored Basic-auth token so subsequent requests keep working.
const ChangePasswordModal = ({ onClose }) => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error('New password must be at least 6 characters'); return; }
    if (next !== confirm) { toast.error('New passwords do not match'); return; }
    setSaving(true);
    try {
      const adminAuth = localStorage.getItem('adminAuth');
      const res = await fetch(`${API_URL}/api/admin/change-password`, {
        method: 'POST',
        headers: { Authorization: `Basic ${adminAuth}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      const data = await res.json();
      if (res.ok) {
        // keep the session valid with the new password
        const username = localStorage.getItem('adminUsername');
        localStorage.setItem('adminAuth', btoa(`${username}:${next}`));
        toast.success('Password updated');
        onClose();
      } else {
        toast.error(data.detail || 'Failed to update password');
      }
    } catch {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4" data-testid="change-password-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-5 border-b">
          <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2"><Lock className="w-5 h-5 text-amber-600" /> Change My Password</h2>
          <button onClick={onClose} className="p-2 text-gray-500 hover:bg-gray-100 rounded" data-testid="close-change-password"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Current Password</label>
            <Input type="password" data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">New Password</label>
            <Input type="password" data-testid="new-password-input" value={next} onChange={(e) => setNext(e.target.value)} placeholder="At least 6 characters" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Confirm New Password</label>
            <Input type="password" data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Re-enter new password" />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={saving} data-testid="submit-change-password" className="bg-amber-600 hover:bg-amber-700">
              {saving ? 'Saving...' : 'Update Password'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
